//
//
//
//
//
//
//
//

import Icon from "../icons";
export default {
  components: {
    Icon
  },
  data() {
    return {};
  },
  methods: {
    refresh(){
      window.location.reload(true);
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/Offline.vue